import { useId, useRef, useState } from "react";
import { TooltipProvider } from "./contexts/TooltipProvider";

export function Tooltip({
  children,
  disabled,
}: {
  children: React.ReactNode;
  disabled?: boolean;
}) {
  const triggerRef = useRef<HTMLElement>(null);
  const [open, setOpen] = useState(false);
  const tooltipId = useId();

  return (
    <TooltipProvider
      disabled={disabled}
      open={disabled ? false : open}
      setOpen={(value) => {
        if (disabled && value) return;
        setOpen(value);
      }}
      tooltipId={tooltipId}
      triggerRef={triggerRef}
    >
      {children}
    </TooltipProvider>
  );
}
